import React from 'react'
import { ProjectsList } from '../components/Projects/ProjectsList'
const ProjectEngagements = () => {
  return (
    <ProjectsList />
  )
}

export  {ProjectEngagements}